module.exports = __webpack_public_path__ + "92288fe0b8add5c85aec71a02a8e31c3.png";